import devConfig from './dev/app'
import prodConfig from './prod/app'

const env = 'prod'
// const env = 'dev'
let webConfig = prodConfig

if (env === 'dev') {
  webConfig = devConfig
}

export default webConfig